export default __webpack_public_path__ + "static/media/hotel.5d1ef00a.svg";